export const BLACK_LIST = ["p4m-pos-app", "test", "staging", "localhost", "192", "pos", "posstaging"];
